import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import avatar from "../../assets/icons/account-circle.svg";
import { postLogout, selectCurrentUser } from "../../features/authentication/services";
import { useSalesLogoutMutation } from "../../features/authentication/services/authApiSlice";
import { apiSlice } from "../../services/api/apiSlice";
import styles from "./UserNav.module.scss";

const UserNav = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const currentUser = useSelector(selectCurrentUser);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [fetchSalesLogout] = useSalesLogoutMutation();

    const handleLogout = async () => {
        setIsOpen(false);
        await fetchSalesLogout().unwrap();
        dispatch(postLogout());
        dispatch(apiSlice.util.resetApiState());
    };

    return (
        <>
            <img className={styles.avatar} src={avatar} alt='avatar' onClick={() => setIsOpen((prev) => !prev)} />
            {isOpen && (
                <>
                    <ul className={styles.avatarMenu}>
                        <li className={styles.item}>{currentUser?.email || ""}</li>
                        <li className={styles.item} onClick={handleLogout}>
                            {t("COMMON.Logout")}
                        </li>
                    </ul>
                    <div className={styles.closeMenu} onClick={() => setIsOpen((prev) => !prev)}></div>
                </>
            )}
        </>
    );
};
export default UserNav;
